@if(navService.getNotificationPane()){
<aside class="secondary-sidepanel"  
       (clickOutside)="navService.toggleNotificationPane()">
  <div class="secondary-sidepanel__content"   @openClose>
    <!-- Notification Screen -->
    <div class="notification-screen-wrapper">
      <div class="notification-screen">
        <div class="notification-screen__header">
          <h5>
            Notifications
           @if(unreadCount | async; as uc){
            <span class="counter">
              ({{ uc }})
            </span>
          }
          </h5>
          @if(unreadCount | async){
            <a  (click)="notificationsService.setAllNotificationsAsRead()">
            <i class="fa-light fa-check-double"></i>
            Mark as read
          </a>
        }
          @if(data.length > 0){
          <a (click)="notificationsService.clearAll()">
            <i class="fa-solid fa-trash-list"></i>
            Clear All
          </a>
          }
        </div>

        <ng-scrollbar style="height: calc(100vh - 160px);">
          <div class="notification-screen__content">
            <!-- Notification Card -->
            @for ( d of data; track $index) {
            <div class="notification-cards" [class]="getNotificationClassNames(d)">
              <div class="notification-cards__content">
                <i [class]="d.icon"></i>
                <div class="details">
                  <span>{{ d. message }}</span>
                  <a class="toggle-action-btn toggle-action-btn--notification-card">
                    {{ moment(d.date).format('DD-MM-YY hh:mm:ss A') }}
                  </a>
                  @if(false){
                  <a class="toggle-action-btn toggle-action-btn--notification-card">
                    More Details
                    <i class="fa-regular fa-arrow-down"></i>
                  </a>
                  }
                </div>
              </div>
            
            </div>
            }

            <!-- Notification Card Alert -->
            <!-- <div class="notification-cards notification-cards--alert">
              <div class="notification-cards__content">
                <i class="fa-light fa-circle-exclamation"></i>
                <div class="details">
                  <span>Your password has been Successfully changed.Please check your email and
                    verify.
                    Code has been sent to your email address as well you can check and verify
                    details
                    everything
                    will be okay to go.
                    Thank you for reaching out cusotmer suppport your ticket id is 96232112</span>
                  <a  class="toggle-action-btn toggle-action-btn--notification-card">
                    More Details
                    <i class="fa-regular fa-arrow-down"></i>
                  </a>
                </div>
              </div>
            </div>

            <div class="notification-cards notification-cards--high-alert">
              <div class="notification-cards__content">
                <i class="fa-light fa-triangle-exclamation"></i>
                <div class="details">
                  <span>Your password has been Successfully changed. </span>
                  <a  class="toggle-action-btn toggle-action-btn--notification-card">
                    More Details
                    <i class="fa-regular fa-arrow-down"></i>
                  </a>
                </div>
              </div>
            </div>

            <div class="notification-cards notification-cards--high-alert">
              <div class="notification-cards__content">
                <i class="fa-light fa-triangle-exclamation"></i>
                <div class="details">
                  <span>Your password has been Successfully changed. </span>
                  <a  class="toggle-action-btn toggle-action-btn--notification-card">
                    More Details
                    <i class="fa-regular fa-arrow-down"></i>
                  </a>
                </div>
              </div>
            </div>

            <div class="notification-cards">
              <div class="notification-cards__content">
                <i class="fa-light fa-thumbs-up"></i>
                <div class="details">
                  <span>Your password has been Successfully changed.</span>
                  <a  class="toggle-action-btn toggle-action-btn--notification-card">
                    More Details
                    <i class="fa-regular fa-arrow-down"></i>
                  </a>
                </div>
              </div>
            </div> -->
          </div>
        </ng-scrollbar>
      </div>
    </div>
  </div>
</aside>
}
